export const UserTypes: any = {
  Scheduler: 2,
  HubUser: 9,
  ExternalFacilityUser: 12
};
